import { combineReducers } from "redux";
import subscriptions from "../features/admin/subscription/Slice";

const subscription = combineReducers({
  subscriptions: subscriptions,
});

export default subscription;
